import {backendURL} from '@/scripts/globals'

export default {
    methods: {
        fileUrl(fileId, download) {
            let url = window.location.href.startsWith(backendURL) ? '' : backendURL
            return download ? `${url}/files/download/${fileId}` : `${url}/files/${fileId}`
        }
    }
}